// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"04648f96","453":"0c54527b","455":"d02dd5f8"}[chunkId] + ".chunk.js";
};